import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { FormTextField } from "@/components/UiKit/FormControls/FormTextField"
import { DOCUMENT_UPLOAD_MIME_TYPES, DOCUMENT_UPLOAD_TYPES_LABEL } from "@/components/upload/constants"
import FileInput from "@/components/upload/FileInput"

export const LotCorrectionAdjustmentFormDetails: FC = () => {
  const { control } = useFormContext()

  return (
    <Box className='flex flex-col overflow-hidden rounded-lg border border-gray-400'>
      <Typography variant='h6' className='p-4 font-bold leading-10'>
        3. Adjustment Details
      </Typography>
      <Box className='flex min-h-0 flex-1 flex-col gap-y-6 overflow-y-auto px-4 pb-4'>
        <FormTextField
          control={control}
          name='comment'
          label='Comment'
          placeholder='Enter comment'
          multiline
          rows={4}
          data-testid='inventory.lot-correction-adjustment-form-details.comment-field'
        />
        <FileInput
          name='document'
          allowedMimeTypes={DOCUMENT_UPLOAD_MIME_TYPES}
          allowedTypesLabel={DOCUMENT_UPLOAD_TYPES_LABEL}
          data-testid='inventory.lot-correction-adjustment-form-details.document-field'
        />
      </Box>
    </Box>
  )
}
